import Triangoli from './class.triangoli';
import Cassa from './class.cassa';
import Cassetti from "./class.cassetti";
import Anta from "./class.anta";
import {sceneManager} from "./class.scenemanager";
import {palette} from "./class.palette";

/**
 * TIPI DI MODULI
 *
 * 0 - Modulo da 60
 * 1 - Modulo da 60x120
 * 2 - Modulo da 60 vuoto
 * 3 - Modulo da 60 con cassetti
 * 4 - Modulo da 60 per texture
 * 5 - Modulo da 60x180
 * 6 - Modulo da 120x60 con cassetti
 */

class Modulo {
    constructor(scene, assetManager, tipo, coord, mobileParent, index, texturePos = false) {
        this._scene = scene;
        this._modulo = new BABYLON.Mesh('moduloParent', this._scene);
        this._modulo.parent = mobileParent;
        this._index = index;
        this._type = tipo;
        this._assetManager = assetManager;
        this._texturePos = texturePos;

        this.generoAnta();

        // genero la cassa
        this._cassa = new Cassa(scene, this._assetManager, this._type, this._modulo);

        this._modulo.position = new BABYLON.Vector3(coord[0], coord[1], coord[2]);
    }
    highlightCassa(status, color) {
        this._cassa.highlightCassa(status, color);
        if (this._anta !== undefined) {
            this._anta.hightlightCornice(status, color, this._cassa._mesh.material.diffuseColor);
        }
    }

    destroy() {
        this._cassa.destroy();
        if ( this._triangoli !== undefined ) {
            this._triangoli.destroy();
        }
        if (this._cassetti !== undefined) {
            this._cassetti.destroy();
        }
        // TODO fare il destroy dell'anta
        this._modulo.dispose();
    }

    extractData() {
        let json = {"indice": this._index, "tipoModulo": this._type };

        if ( this._type !== 2 && (sceneManager.appMode === 1 || sceneManager.appMode === 0) ) {
            json.listaTriangoli = this._triangoli.extractData();
        } else if (sceneManager.appMode !== 1) {
            if (this._anta !== undefined) {
                json.textureVisible = this._anta._mesh.textureVisible;
                json.currentTexture = this.getFilename(this._anta._currentTexture.name);
                json.currentColor = this._anta.extractColor();
            } else {
                json.empty = true;
            }
        }

        return json;
    }

    getFilename(url) {
        if (url) {
            var m = url.toString().match(/.*\/(.+?)\./);
            if (m && m.length > 1) {
                return m[1];
            }
        }
        return "";
    }

    toggleOutline(status) {
        // se non è la cassa senza triangoli
        if ( this._type !== 2  ) {
            this._triangoli.toggleOutline(status);
        }

    }

    generoAnta()
    {
        if ( this._type !== 2 && (sceneManager.appMode === 1 || sceneManager.appMode === 0) ) {
            // genero i triangoli
            this._triangoli = new Triangoli(this._scene, this._assetManager, this._type, this._modulo);
        }
        if (this._type === 3 || this._type === 6) {
            this._cassetti = new Cassetti(this._scene, this._assetManager, this._type, this._modulo);
        }
        if (this._type !== 2 && sceneManager.appMode > 1) {
            console.log( 'anta' );
            this._anta = new Anta(this._scene, this._assetManager, this._modulo, this._type, this._texturePos[0], this._texturePos[1]);
        }
    }


}

/*module.exports = Modulo;*/

export default Modulo;
